var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8709 9.91406C25.7847 9.91406 21.7902 11.1258 18.3927 13.3959C14.9951 15.6661 12.3471 18.8928 10.7834 22.6679C9.21965 26.4431 8.8105 30.5971 9.60768 34.6048C10.4049 38.6125 12.3725 42.2938 15.2619 45.1832C18.1513 48.0725 21.8326 50.0402 25.8403 50.8374C29.8479 51.6346 34.002 51.2254 37.7772 49.6617C41.5523 48.098 44.779 45.4499 47.0492 42.0524C49.3193 38.6549 50.531 34.6604 50.531 30.5742C50.531 27.8611 49.9966 25.1745 48.9584 22.6679C47.9201 20.1613 46.3983 17.8838 44.4798 15.9653C42.5613 14.0468 40.2838 12.525 37.7772 11.4867C35.2706 10.4485 32.584 9.91406 29.8709 9.91406ZM29.8709 47.1024C26.6019 47.1024 23.4064 46.133 20.6883 44.3169C17.9703 42.5007 15.8518 39.9194 14.6009 36.8993C13.3499 33.8791 13.0226 30.5559 13.6603 27.3497C14.2981 24.1436 15.8722 21.1986 18.1837 18.8871C20.4952 16.5756 23.4402 15.0014 26.6464 14.3637C29.8525 13.7259 33.1758 14.0532 36.1959 15.3042C39.216 16.5552 41.7974 18.6736 43.6135 21.3917C45.4296 24.1097 46.399 27.3053 46.399 30.5742C46.399 34.9578 44.6576 39.1618 41.558 42.2614C38.4584 45.361 34.2544 47.1024 29.8709 47.1024Z",
    fill: "url(#paint0_radial_8525_70770)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8739 24.3723C31.0149 24.3723 31.9399 23.4473 31.9399 22.3063C31.9399 21.1652 31.0149 20.2402 29.8739 20.2402C28.7328 20.2402 27.8079 21.1652 27.8079 22.3063C27.8079 23.4473 28.7328 24.3723 29.8739 24.3723Z",
    fill: "url(#paint1_radial_8525_70770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8736 26.4424C29.3257 26.4424 28.8002 26.6601 28.4127 27.0475C28.0253 27.435 27.8076 27.9605 27.8076 28.5084V38.8385C27.8076 39.3864 28.0253 39.9119 28.4127 40.2994C28.8002 40.6868 29.3257 40.9045 29.8736 40.9045C30.4216 40.9045 30.9471 40.6868 31.3345 40.2994C31.722 39.9119 31.9396 39.3864 31.9396 38.8385V28.5084C31.9396 27.9605 31.722 27.435 31.3345 27.0475C30.9471 26.6601 30.4216 26.4424 29.8736 26.4424Z",
    fill: "url(#paint2_radial_8525_70770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8525_70770",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.531 9.91406) rotate(135) scale(58.4358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB71A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376712,
    stopColor: "#FF9E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674419,
    stopColor: "#F9831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26522"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8525_70770",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9399 20.2402) rotate(135) scale(5.84358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB71A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376712,
    stopColor: "#FF9E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674419,
    stopColor: "#F9831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26522"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8525_70770",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.13203 14.4621 -4.13203 -14.4621 31.9396 26.4424)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB71A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376712,
    stopColor: "#FF9E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674419,
    stopColor: "#F9831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26522"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconAb);
export default __webpack_public_path__ + "static/media/infoIcon_ab.b607f49d93e68ee6e84da3ed23ec5675.svg";
export { ForwardRef as ReactComponent };